import React from 'react';
import BrowserCompatibilityNotification from './Common/BrowserCompatibilityNotification';
import { AccountContextProvider } from './Data/accountContext';

import RegistrationRoute from './RegistrationRoute';

export default function Registration(props) {
  const { key: verificationKey, form } = props.params.match.params;

  return (
    <div className="register-w">
      <BrowserCompatibilityNotification />
      <AccountContextProvider>
        <RegistrationRoute
          path="/registration/:form/:key?"
          form={form}
          redirectPath={`/registration/account/${verificationKey || ''}`}
        />
      </AccountContextProvider>
    </div>
  );
}
